import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteGeneralIncome } from '../../../../actions';

class GeneralIncomeDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteGeneralIncome, generalIncomeId } = this.props;
    dispatchDeleteGeneralIncome({ generalIncomeId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

GeneralIncomeDeleteButton.propTypes = {
  generalIncomeId: PropTypes.number.isRequired,
  dispatchDeleteGeneralIncome: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteGeneralIncome: deleteGeneralIncome,
};

export default connect(null, mapDispatchToProps)(GeneralIncomeDeleteButton);
